import { SELECT_ALL_FILTERS } from "../../utils/constants/constants";
import FilterItem from "./FilterItem";

export default function GeneralSelectAll(props) {
  const {
    select,
    type,
    filters,
    filterUuid,
    additionalTheme,
    finalFiltersBeforePagination,
    searchValue,
  } = props;
  const { selectAllIncluded = {} } = additionalTheme ?? {};
  const items = searchValue ? filters : finalFiltersBeforePagination;

  const remainingFilters = finalFiltersBeforePagination.filter(
    (candidateFilter) =>
      !filters.some(
        (activeFilter) => activeFilter.value === candidateFilter.value
      )
  );

  const isAllFiltersSelected =
    items.length && items.every((filter) => filter.checked);

  if (!selectAllIncluded[filterUuid]) {
    return null;
  }

  function selectAll() {
    const selected = items.map((filter) => ({
      ...filter,
      checked: !isAllFiltersSelected,
    }));

    select([...selected, ...remainingFilters], SELECT_ALL_FILTERS);
  }

  return (
    <FilterItem
      name={`Select All${searchValue ? " (visibles)" : ""}`}
      checked={isAllFiltersSelected ? "checked" : ""}
      onChange={selectAll}
      cy="filter-menu-input-select-all"
      type={type}
    />
  );
}
